import React from 'react'
import { Skeleton, Card, Box, Stack, Grid2 } from '@mui/material'

const LoadingSkeleton = () => {
  return (
    <Grid2 container spacing={3}>
      <Grid2 size={{ xs: 12, md: 4 }}>
        <Card sx={{ p: 3 }}>
          <Skeleton
            variant='text'
            width='60%'
            height={40}
            sx={{ mx: 'auto' }}
          />
          <Skeleton
            variant='text'
            width='80%'
            height={20}
            sx={{ mx: 'auto', mb: 1 }}
          />

          <Skeleton
            variant='text'
            width='50%'
            height={20}
            sx={{ mx: 'auto', mb: 2 }}
          />

          <Box
            sx={{
              my: { xs: 2, md: 3, height: 215 },
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            <Skeleton variant='rectangular' width={215} height={215} />
          </Box>

          <Skeleton
            variant='text'
            width='70%'
            height={20}
            sx={{ mx: 'auto' }}
          />

          <Stack alignItems='center' sx={{ mt: 3 }}>
            <Skeleton width={160} height={36} />
          </Stack>
        </Card>
      </Grid2>
      <Grid2 size={{ xs: 12, md: 4 }}>
        <Stack spacing={3}>
          <Card sx={{ p: 3 }}>
            <Skeleton variant='text' width='40%' height={40} />
            <Box
              sx={{
                rowGap: 3,
                columnGap: 2,
                display: 'grid',
                gridTemplateColumns: {
                  xs: 'repeat(1, 1fr)',
                  sm: 'repeat(2, 1fr)'
                }
              }}
            >
              <Skeleton height={56} />
              <Skeleton height={56} />
            </Box>

            <Stack spacing={3} sx={{ mt: 3, alignItems: 'flex-end' }}>
              <Skeleton width={100} height={36} />
            </Stack>
          </Card>
          <Card sx={{ p: 3 }}>
            <Skeleton variant='text' width='40%' height={40} />
            <Skeleton variant='text' width='80%' height={20} sx={{ mb: 1 }} />
            <Skeleton variant='text' width='80%' height={20} sx={{ mb: 2 }} />
            <Skeleton height={56} />
            <Stack spacing={3} sx={{ mt: 3, alignItems: 'flex-end' }}>
              <Skeleton width={100} height={36} />
            </Stack>
          </Card>
        </Stack>
      </Grid2>
      <Grid2 size={{ xs: 12, md: 4 }}>
        <Card sx={{ p: 3 }}>
          <Skeleton variant='text' width='40%' height={40} />
          <Skeleton variant='text' width='90%' height={20} sx={{ mb: 1 }} />
          <Skeleton variant='text' width='90%' height={20} sx={{ mb: 1 }} />
          <Skeleton variant='text' width='90%' height={20} sx={{ mb: 2 }} />

          <Skeleton
            variant='rectangular'
            height={100}
            sx={{ borderRadius: 1 }}
          />

          <Stack
            direction='row'
            justifyContent='flex-end'
            spacing={2}
            sx={{ mt: 3 }}
          >
            <Skeleton width={80} height={36} />
            <Skeleton width={100} height={36} />
          </Stack>
        </Card>
      </Grid2>
    </Grid2>
  )
}

export default LoadingSkeleton
